import { useEffect, useRef } from "react";
import { useAuth } from "../providers/AuthProvider";
import HeartbeatService from "../services/HeartbeatService";

export const useHeartbeat = () => {
  const { userLogged } = useAuth();
  const intervalRef = useRef<NodeJS.Timeout | null>(null);
  const isPageVisibleRef = useRef(true);

  useEffect(() => {
    // Função para iniciar o heartbeat
    const startHeartbeat = () => {
      if (!userLogged || intervalRef.current) return;

      // Enviar heartbeat imediatamente
      HeartbeatService.sendHeartbeat();

      // Enviar a cada 60 segundos
      intervalRef.current = setInterval(() => {
        if (isPageVisibleRef.current) {
          HeartbeatService.sendHeartbeat();
        }
      }, 60000); // 60 segundos
    };

    // Função para parar o heartbeat
    const stopHeartbeat = () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    };

    // Monitorar visibilidade da página
    const handleVisibilityChange = () => {
      isPageVisibleRef.current = !document.hidden;

      if (isPageVisibleRef.current && userLogged) {
        // Retomar: enviar heartbeat quando volta
        HeartbeatService.sendHeartbeat();
      }
    };

    // Monitorar foco/blur da janela
    const handleFocus = () => {
      isPageVisibleRef.current = true;
      if (userLogged) {
        HeartbeatService.sendHeartbeat();
      }
    };

    const handleBlur = () => {
      isPageVisibleRef.current = false;
    };

    // Iniciar heartbeat quando usuário faz login
    if (userLogged) {
      startHeartbeat();

      // Adicionar event listeners
      document.addEventListener("visibilitychange", handleVisibilityChange);
      window.addEventListener("focus", handleFocus);
      window.addEventListener("blur", handleBlur);

      return () => {
        // Limpar quando usuário deslogar ou componente desmontar
        stopHeartbeat();
        document.removeEventListener("visibilitychange", handleVisibilityChange);
        window.removeEventListener("focus", handleFocus);
        window.removeEventListener("blur", handleBlur);
      };
    } else {
      // Parar heartbeat quando deslogar
      stopHeartbeat();
    }
  }, [userLogged]);
};
